export default function Transaction(data) {
  this.itemId = data && data.itemId ? data.itemId : 0;
  this.category = data && data.category ? data.category : '';
  this.category = this.category && data.otherCat ? data.otherCat : this.category;
  this.itemTitle = data && data.itemTitle ? data.itemTitle : '';
  this.transactionType = data && data.transactionType ? data.transactionType : '';
  this.transactionDate = data && data.transactionDate ? data.transactionDate : new Date();
  this.transactionValue = data && data.transactionValue ? data.transactionValue : 0;
  this.contactId = data && data.contactId ? data.contactId : 0;
  this.gain = data && data.gain ? data.gain : 0;
  this.cumulativeTotal = data && data.cumulativeTotal ? data.cumulativeTotal : 0;
}

export const txToApiMap = [
  ['itemId', 'itemId'],
  ['category', 'itemCat'],
  ['otherCat', 'otherCat'],
  ['itemTitle', 'title'],
  ['transactionType', 'transactionType'],
  [
    'transactionDate',
    apiObj => ({ transactionDate: new Date(`${apiObj.transactionDate} 12:00:00`) }),
    modelObj => ({ transactionDate: modelObj.transactionDate.toISOString().substr(0, 10) }),
  ],
  ['transactionValue', 'transactionValue'],
  ['contactId', 'contactId'],
  ['gain', 'gain'],
  ['cumulativeTotal', 'cumulativeTotal'],
];



// WEBPACK FOOTER //
// ./src/models/Transaction.js